import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Tabs } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import {
  CASH_APPROACH,
  fetchBlotter,
  fetchMarketRegimes,
  HISTORICAL_SCENARIO,
  selectors,
} from 'state';
import CashExchange from './CashExchange';
import Orders from './Orders';
import './blotterTabV5.css';

const useFillHeight = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>();

  useLayoutEffect(() => {
    const measure = () => {
      if (!ref.current) return;
      const top = ref.current.getBoundingClientRect().top;
      setHeight(Math.max(440, window.innerHeight - top - 10));
    };

    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  return { ref, height };
};

const BlotterTabV5: React.FC = () => {
  const dispatch = useDispatch();
  const session = useSelector(selectors.activeSession);
  const { fetched_blotter: fetchedBlotter, fetching_blotter: fetchingBlotter } =
    useSelector(selectors.player);
  const isCashApproach = session.risk_approach === CASH_APPROACH;
  const isHistorical = session.scenario_type === HISTORICAL_SCENARIO;
  const [tab, setTab] = useState('orders');
  const fillHeight = useFillHeight();

  useEffect(() => {
    if (!fetchedBlotter && !fetchingBlotter) dispatch(fetchBlotter({}));
  }, [dispatch, fetchedBlotter, fetchingBlotter]);

  useEffect(() => {
    if (isHistorical && session.id) {
      dispatch(fetchMarketRegimes({ session_id: session.id }));
    }
  }, [dispatch, isHistorical, session.id]);

  useEffect(() => {
    if (!isCashApproach && tab === 'fx-spot') setTab('orders');
  }, [isCashApproach, tab]);

  return (
    <div
      ref={fillHeight.ref}
      className="blotter-v5"
      style={{ height: fillHeight.height }}
    >
      <Tabs
        activeKey={tab}
        onChange={setTab}
        items={[
          { key: 'orders', label: 'Orders' },
          ...(isCashApproach
            ? [{ key: 'fx-spot', label: 'Cash Exchange' }]
            : []),
        ]}
      />
      <div className="blotter-v5__content">
        {tab === 'orders' ? <Orders /> : <CashExchange />}
      </div>
    </div>
  );
};

export default BlotterTabV5;
